import Tr from "translations/Translations";

export const OfferEvaluationRoundType = {
    BASE: "base",
    ADDITIONAL_OFFERS: "additional_offers",
    AUCTION: "auction"
}
const _TR_PREFIX = 'offer_evaluation_round_type_';

export const OfferEvaluationRoundTypeLabel = (type) => (Tr(_TR_PREFIX + type));
